var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtalogoWt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.909 26.3309L33.524 26.0426V43.9809L28.4792 44.8729L28.4669 25.599L24.1798 25.2196V18.1551L36.909 20.3765V26.3309ZM46.516 41.7115L43.5222 42.2302L43.173 39.6158L40.2569 39.994L39.8917 42.8708L36.0353 43.5521L39.8534 20.9321L43.4778 21.5605L46.516 41.7115ZM42.6399 35.1965L41.8377 28.2898H41.6625L40.8505 35.3012L42.6399 35.1965ZM25.9618 62.7483C43.2211 62.7483 57.2077 48.7008 57.2077 31.3748C57.209 14.0451 43.2223 0 25.963 0C15.1417 0 5.60872 5.52317 0 13.917L8.65928 15.441L11.0422 33.6503C11.0509 33.6208 11.215 33.6392 11.215 33.6392L13.8287 16.3465L22.4941 17.8607V45.9299L17.0249 46.886V34.8245C17.0249 34.8245 17.2272 29.629 17.1075 28.7407C17.1075 28.7407 16.8694 28.7469 16.8657 28.7272L13.6029 47.4983L8.16936 48.4556L4.176 28.2356L3.93536 28.2183C3.85021 28.9501 4.22783 35.2951 4.22783 35.2951V49.1468L0.656511 49.7739C6.33681 57.6342 15.5539 62.7483 25.9618 62.7483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 62.8333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtalogoWt);
export default __webpack_public_path__ + "static/media/mtalogo_wt.e087e89e18727b4ec04874c3b12288bf.svg";
export { ForwardRef as ReactComponent };